// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"61":"b6580dc5","295":"184211a6","368":"b8654778","514":"76597e42","544":"4748a9ca","577":"53896559","869":"d3f7df9f","870":"2a625885"}[chunkId] + ".chunk.css";
};